import { useCallback } from 'react';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import type { IsEditableFunction } from '../types';

import { useOrganisationAreaContext } from './use-organisation-area-context';

const editableSections = ['groups', 'categories'];
const editableEntityGroups = [
  Entities.project,
  Entities.customer,
  Entities.supplier,
  Entities.article,
  Entities.wordDocumentTemplate,
  Entities.wordLetterTemplate,
  Entities.salesOpportunities,
  Entities.textBuildingBlock,
];
const editableEntityCategories = [Entities.customer, Entities.supplier];

export const useOrganisationAreaSectionEditability = () => {
  const { entity } = useOrganisationAreaContext();

  const isEditable = useCallback<IsEditableFunction>(
    (section) => {
      return (
        editableSections.includes(section) &&
        ((section === 'groups' && editableEntityGroups.includes(entity)) ||
          (section === 'categories' &&
            editableEntityCategories.includes(entity)))
      );
    },
    [entity]
  );

  return { isEditable };
};
